import angular from 'angular';
import moment from 'moment-timezone';

class Dosespot {
  constructor($http, $q, $filter, Endpoints, Auth, Utils, DOSESPOT_CLINIC_ID, DOSESPOT_SIGN_ON, DOSESPOT_API, DOSESPOT_KEY) {
    'ngInject';

    Object.assign(this, {
      DOSESPOT_KEY,
      DOSESPOT_SIGN_ON,
      DOSESPOT_API,
      DOSESPOT_CLINIC_ID,
      $q,
      $http,
      $filter,
      Endpoints,
      Auth,
      Utils
    });
  }

  _generateRandomPhrase() {
    // Random phrase will always be 32 characters long
    const PHRASE_LENGTH = 32; // Create array of phrase byte possibilites

    const possibilites = [].createRange('a', 'z').concat([].createRange('A', 'Z')).concat([].createRange('0', '9'));
    let phrase = '';

    for (let i = 0; i < PHRASE_LENGTH; i++) {
      phrase += possibilites[_.random(0, PHRASE_LENGTH - 1)];
    }

    return phrase;
  }

  _hashify(str) {
    // Convert argument to UTF8 String
    const hash = unescape(encodeURIComponent(str)); // Use SHA512 to hash the byte value, get base64string out of hash, and remove extra equal signs
    // eslint-disable-next-line new-cap

    return CryptoJS.enc.Base64.stringify(CryptoJS.SHA512(hash)).replace(/=/g, '');
  }

  _createSignOnPhrase() {
    // Create a random phrase 32 characters long in UTF8
    let phrase = this._generateRandomPhrase(); // Append a hash of the generated phrase combined with Dosespot Key


    phrase += this._hashify(phrase + this.DOSESPOT_KEY); // Return url-encoded phrase

    return encodeURIComponent(phrase);
  }

  _createUserPhrase(first22, doctorId) {
    // User Id + First 22 characters of Sign On Phrase + Dosespot Key
    const phrase = doctorId + first22 + this.DOSESPOT_KEY; // Return url-encoded hashed phrase

    return encodeURIComponent(this._hashify(phrase));
  }

  _formPatientPayload(patient) {
    return {
      FirstName: patient.firstname,
      LastName: patient.lastname,
      Gender: _.capitalize(patient.gender),
      DateOfBirth: moment.utc(patient.dob).format('DD/MMM/YYYY'),
      Address1: patient.address.road,
      City: patient.address.city,
      State: patient.address.state,
      ZipCode: patient.address.zip,
      PrimaryPhone: this.$filter('phoneNumber')(patient.cell),
      PrimaryPhoneType: 'Home',
      PatientId: patient.properties && patient.properties.dosespot
    };
  }

  updatedDosespotInfo(id) {
    return this.$http.put(this.Endpoints.orders.dosespothistorycounts.replace(':id', id), {}, {
      loadingText: 'Updating Dosespot info for this visit'
    });
  }

  createPatient(patient) {
    const payload = {
      user_id: patient.id
    };
    return this.$http.post(this.Endpoints.dosespot.patient, payload, {
      loadingText: 'Creating Dosespot Patient'
    });
  }

  createCredentials() {
    // https://app.asana.com/0/333364685358613/418538777242794
    //
    //    const UserId = this.Auth.profile.properties.dosespot;
    //
    const UserId = this.Auth.profile.properties.dosespot_clinician_id;

    const SingleSignOnCode = this._createSignOnPhrase();

    const SingleSignOnUserIdVerify = this._createUserPhrase(SingleSignOnCode.substring(0, 22), UserId);

    return {
      SingleSignOnClinicId: this.DOSESPOT_CLINIC_ID,
      SingleSignOnUserId: UserId,
      SingleSignOnPhraseLength: 32,
      SingleSignOnCode,
      SingleSignOnUserIdVerify
    };
  }

  getPatientLink(patient) {
    const credentials = this.createCredentials();
    const payload = Object.assign(credentials, this._formPatientPayload(patient));
    const url = `${this.DOSESPOT_SIGN_ON + this.Utils.serializeQuery(payload)}`;
    return this.$q.when(url);
  }

  getRefillLink() {
    return this.$q.when(`${this.DOSESPOT_SIGN_ON + this.Utils.serializeQuery(this.createCredentials())}&RefillsErrors=1`);
  }

}

Dosespot.$inject = ["$http", "$q", "$filter", "Endpoints", "Auth", "Utils", "DOSESPOT_CLINIC_ID", "DOSESPOT_SIGN_ON", "DOSESPOT_API", "DOSESPOT_KEY"];
angular.module('pims').service('Dosespot', Dosespot);
